/**
 * 供应商绩效枚举定义
 */

/**
 * 供应商绩效等级
 */
export enum SupplierPerformanceLevel {
  /** A级（优选） */
  A = 1,
  /** B级（合格） */
  B = 2,
  /** C级（观察） */
  C = 3,
  /** D级（淘汰） */
  D = 4,
}

/**
 * 预警类型
 */
export enum SupplierAlertType {
  /** 绩效下滑 */
  PERFORMANCE_DECLINE = 1,
  /** 低绩效 */
  LOW_PERFORMANCE = 2,
  /** 高索赔率 */
  HIGH_CLAIM_RATE = 3,
  /** 交期异常 */
  DELIVERY_ABNORMAL = 4,
}
